import UIComponent from "../../ui/component";
export class ResultTabsMobileSelect extends UIComponent {

    #outsideClickHandler = null;

    init() {
        this.dropdownBtn?.on("click", (e) => {
            e.stopPropagation();
            this.toggle();
        });

        this.dropdownList?.on("click", this.handleListClick.bind(this));

        this.#outsideClickHandler = (e) => {
            if (!this.el()?.contains(e.target)) this.setOpen(false);
        };
        document.addEventListener("click", this.#outsideClickHandler);
    }

    destroy() {
        if (this.#outsideClickHandler) {
            document.removeEventListener("click", this.#outsideClickHandler);
        }
    }

    isOpen() {
        return this.dropdownList?.attr("aria-hidden") === "false";
    }

    toggle() {
        const open = !this.isOpen();
        if (open) this.closeAllBootstrapDropdowns();
        this.setOpen(open);
    }

    setOpen(open) {
        this.dropdownBtn?.attr("aria-expanded", String(open));
        this.dropdownList?.attr("aria-hidden", String(!open));
        if (open) this.closeAllBootstrapDropdowns();
    }

    closeAllBootstrapDropdowns() {
        const openDropdowns = document.querySelectorAll(
            ".dropdown.show, .dropdown-menu.show"
        );
        openDropdowns.forEach((dropdown) => {
            const dropdownElement = dropdown.classList.contains("dropdown")
                ? dropdown
                : dropdown.closest(".dropdown");
            if (!dropdownElement) return;

            if (window.bootstrap?.Dropdown) {
                const bsDropdown =
                    window.bootstrap.Dropdown.getInstance(dropdownElement);
                if (bsDropdown) {
                    bsDropdown.hide();
                    return;
                }
            }

            const button = dropdownElement.querySelector(
                '[data-bs-toggle="dropdown"]'
            );
            if (button && button.getAttribute("aria-expanded") === "true") {
                button.click();
            }
        });
    }

    handleListClick(e) {
        const item = e.target.closest(".result-tabs__dropdown-item");
        if (!item) return;

        if (e.target.closest(".result-tabs__dropdown-delete")) {
            e.stopPropagation();
            const tabId = item.dataset.id;
            const tabName =
                item.querySelector(".result-tabs__dropdown-item-text")?.textContent ||
                "";
            const deleteUrl =
                e.target
                    .closest(".result-tabs__dropdown-delete")
                    ?.getAttribute("data-tab-url") || null;

            this.parent?.handleTabDeleteRequest?.({
                tabId,
                tabName,
                deleteUrl,
                source: "mobile",
            });
            return;
        }

        const tabId = item.dataset.id;
        this.parent?.handleTabSelect?.(tabId);
        this.setOpen(false);
    }

    getActiveId() {
        const active = this.dropdownList?.find(
            ".result-tabs__dropdown-item--active"
        );
        return active?.dataset?.id || null;
    }

    setActiveById(tabId) {
        this.dropdownList
            ?.findAll(".result-tabs__dropdown-item")
            ?.forEach((el) => {
                el.classList.toggle(
                    "result-tabs__dropdown-item--active",
                    el.dataset.id === String(tabId)
                );
            });
    }

    removeById(tabId) {
        this.dropdownList?.find(`[data-id="${tabId}"]`)?.remove();
    }

    insertAfterActive(el) {
        const active = this.dropdownList?.find(
            ".result-tabs__dropdown-item--active"
        );
        if (active && el) {
            active.insertAdjacentElement("afterend", el);
        } else if (this.dropdownList?.el() && el) {
            this.dropdownList.el().appendChild(el);
        }
    }

    syncButtonLabelFromDesktop(activeDesktopTabEl) {
        const tabButton = activeDesktopTabEl?.querySelector(".result-tabs__tab");
        const activeText = tabButton?.textContent || "";
        const isAiTab = tabButton?.classList.contains("ai-btn") || false;

        const textEl = this.dropdownBtn?.find(".result-tabs__dropdown-text");
        if (!textEl || !activeText) return;

        textEl.textContent = activeText;
        if (isAiTab) {
            textEl.classList.add("ai-btn");
            textEl.style.paddingInlineStart = "24px";
        } else {
            textEl.classList.remove("ai-btn");
            textEl.style.paddingInlineStart = "";
        }
    }
}


